/**
 * ¿La página corre dentro de un iframe? (la landing embebe el share).
 * Leer `window.top` con otro origen puede tirar: ante la duda, embebido.
 *
 * @param {Window} [win]
 * @returns {boolean}
 */
export function isEmbeddedFrame(win = typeof window !== 'undefined' ? window : undefined) {
  if (!win) return false;
  try {
    return win.self !== win.top;
  } catch (_) {
    return true;
  }
}
